import { useState, useEffect } from 'react';
import axios from 'axios';
import './NpsStoreSurveyForm.css';
import SendSurveyButton from '../SendSurveyButton';
import SurveyError from '../SurveyError';
import ReasonsSelector from '../ReasonsSelector';
import CommentField from '../CommentField';
import ScoreSelector from '../ScoreSelector';

const NpsStoreSurveyForm = () => {
  const [score, setScore] = useState(null);
  const [reasons, setReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState(null);
  const [comment, setComment] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const apiGetUrl = process.env.REACT_APP_GET_REASONS_API_URL;

    axios.get(`${apiGetUrl}?survey_type=LOJAS_FISICAS`)
      .then(response => {
        const sortedReasons = response.data.records.sort((a, b) => a.id - b.id);
        setReasons(sortedReasons);
        setErrorMessage(null);
      })
      .catch(error => {
        setErrorMessage('Erro ao carregar os motivos. Tente novamente mais tarde.')
      });

    const params = new URLSearchParams(window.location.search);
    const initialScore = parseInt(params.get('score'));
    if (!isNaN(initialScore)) {
      setScore(initialScore);
    }
  }, []);

  const handleScoreSelect = (selectedScore) => {
    setScore(selectedScore);
  };


  const handleReasonSelect = (reasonId) => {
    const reason = reasons.find(r => r.id === reasonId);
    setSelectedReason(reason);
  };


  return (
    <div>
      <SurveyError errorMessage={errorMessage} />
      <ScoreSelector score={score} handleScoreSelect={handleScoreSelect} />
      {score !== null && (
        <ReasonsSelector
          reasons={reasons.filter(reason => score >= reason.min_score && score <= reason.max_score)}
          selectedReason={selectedReason}
          onReasonSelect={handleReasonSelect}
        />
      )}

      {selectedReason && (
        <CommentField comment={comment} setComment={setComment} />
      )}

      <SendSurveyButton
        survey={{ score, reason_id: selectedReason?.id, comment }}
        id={new URLSearchParams(window.location.search).get('id')}
        setErrorMessage={setErrorMessage}
      />
    </div>
  );
};
export default NpsStoreSurveyForm;
